module.exports = __webpack_public_path__ + "img/guangzhou_tu.6c50f67d.png";